"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
var api_constants_1 = require("../constants/api.constants");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var BaseService = /** @class */ (function () {
    function BaseService(options) {
        this.options = options;
    }
    BaseService.prototype.getEnrollmentPeriodHeader = function () {
        var schoolYear = this.options.authContextState.schoolYear;
        return {
            'enrollment-period': schoolYear === null || schoolYear === void 0 ? void 0 : schoolYear.id,
        };
    };
    /**
     * It defines the headers for the clients.
     * @param customHeaderParams
     */
    BaseService.prototype.getDefaultHeaders = function (customHeaderParams) {
        var currentSchoolYear = this.getEnrollmentPeriodHeader();
        var headerObj = __assign({ 'GM-Platform': (customHeaderParams === null || customHeaderParams === void 0 ? void 0 : customHeaderParams.isDigitalLicense) ? api_constants_1.DIGITAL_KEY_TOKEN : api_constants_1.APPLICATION_TOKEN }, currentSchoolYear);
        if (!(0, isEmpty_1.default)(customHeaderParams)) {
            var customEnrollmentPeriod = customHeaderParams.customEnrollmentPeriod, curriculumId = customHeaderParams.curriculumId;
            if (customEnrollmentPeriod) {
                if (customEnrollmentPeriod !== currentSchoolYear['enrollment-period']) {
                    // @ts-ignore
                    headerObj.historicalSchoolYear = true;
                }
                headerObj['enrollment-period'] = customEnrollmentPeriod;
            }
            if (curriculumId) {
                headerObj['curriculum-id'] = curriculumId;
            }
        }
        return headerObj;
    };
    Object.defineProperty(BaseService.prototype, "retryOnNonAuthorizedEnabled", {
        get: function () {
            return this.options && !!this.options.retryOptionsOnNonAuthorized;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * It defines the headers the roster api calls
     */
    BaseService.prototype.getRosterDefaultHeaders = function () {
        return __assign({ 'x-override-fake-token': true, 'GM-Platform': api_constants_1.APPLICATION_TOKEN }, this.getEnrollmentPeriodHeader());
    };
    return BaseService;
}());
exports.BaseService = BaseService;
